import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import JobsPage from "@/pages/JobsPage";
import JobFormPage from "@/pages/JobFormPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderFormPage from "@/pages/OrderFormPage";
import CostsPage from "@/pages/CostsPage";
import CollectionsPage from "@/pages/CollectionsPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";
import KanbanPage from "@/pages/KanbanPage";
import CalendarPage from "@/pages/CalendarPage";
import DashboardPage from "@/pages/DashboardPage";
import ReportsPage from "@/pages/ReportsPage";
import ReceivablesReportPage from "@/pages/ReceivablesReportPage";
import CustomersPage from "@/pages/CustomersPage";
import CustomerDetailPage from "@/pages/CustomerDetailPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
        <Routes>
          <Route path="/giris" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/musteriler" element={<CustomersPage />} />
            <Route path="/musteriler/:id" element={<CustomerDetailPage />} />
            <Route path="/isler" element={<JobsPage />} />
            <Route path="/isler/yeni" element={<JobFormPage />} />
            <Route path="/isler/:id" element={<JobFormPage />} />
            <Route path="/siparisler" element={<OrdersPage />} />
            <Route path="/siparisler/yeni" element={<OrderFormPage />} />
            <Route path="/siparisler/:id" element={<OrderFormPage />} />
            <Route path="/operasyon/kanban" element={<KanbanPage />} />
            <Route path="/operasyon/takvim" element={<CalendarPage />} />
            <Route
              path="/maliyetler"
              element={<CostsPage />}
            />
            <Route
              path="/tahsilatlar"
              element={<CollectionsPage />}
            />
            <Route
              path="/raporlar"
              element={<ReportsPage />}
            />
            <Route
              path="/raporlar/alacaklar"
              element={<ReceivablesReportPage />}
            />
            <Route
              path="/kullanicilar"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ayarlar"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
